import { IAppState } from '../../redux';
import { MOSCOW } from '../../constants';

export const selectRegionId = (state: IAppState) => {
  const { offer } = state;

  if (offer.geo && offer.geo.address && offer.geo.address[0]) {
    return offer.geo.address[0].id;
  }

  return MOSCOW;
};
